import GTM from './gtm'

export default GTM
